import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#0f3e3e] text-white mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 grid gap-12 md:grid-cols-4">

        {/* Brand */}
        <div>
          <h3 className="text-xl font-semibold mb-4">
            Safety Training Institute
          </h3>
          <p className="text-sm text-white/80 leading-relaxed">
            Professional safety training & certification center based in
            Bahanaga, Balasore, Odisha. Industry-oriented training for real-world
            workplaces.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/courses" className="hover:text-white">Courses</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
          </ul>
        </div>

        {/* Policies */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Policies</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li>
              <Link to="/privacy-policy" className="hover:text-white">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms" className="hover:text-white">
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/shipping" className="hover:text-white">
                Shipping Policy
              </Link>
            </li>
            <li>
              <Link to="/refund-policy" className="hover:text-white">
                Cancellation & Refund Policy
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 mt-0.5" />
              Bahanaga, Balasore, Odisha – 756042
            </li>
            <li className="flex gap-3">
              <Phone className="w-4 h-4" />
              +91 9938232920
            </li>
            <li className="flex gap-3">
              <Mail className="w-4 h-4" />
              info@safetytraininginstitute.org.in
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row justify-between items-center text-sm text-white/70">
          <p>
            © {new Date().getFullYear()} Safety Training Institute. All rights
            reserved.
          </p>
          <p className="mt-2 md:mt-0">
            Developed by <Link to="https://www.thecodebazaar.com/" className="hover:text-white">Website Developer's</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
